import router from '@/router';

const archiveCardsTypes = {
    ArchiveIncomingDocument: "Document",
    ArchiveOutgoingDocument: "Document",
    ArchiveOutgoingDocumentCommon: "Document",
    ArchiveInnerDocument: "Document",
    ArchiveResolution: "Resolution",
    ArchiveActItem: "Resolution",
    ArchiveEuolStatement: "Euol",
    ArchiveEuolAnswer: "Document",
    ArchiveEuolAnswerCommon: "Document",
    ArchiveEuolResolution: "Resolution"
};

const archiveDocumentToolbar = [
    {
        Action: "Print",
        Icon: "print",
        Items: [
        {
            Action: "PrintCard",
            Icon: "print",
            Items: null,
            Text: "Печать_карточки",
            ToolTip: "Печать_карточки_документа",
            Type: "Chancellery|Documents|CitizenStatements.DocumentCard",
            Localize: true
        },
        {
            Action: "PrintHistory",
            Icon: "print",
            Items: null,
            Text: "Печать_истории",
            ToolTip: "Печать_истории_документа",
            Type: "Chancellery|Documents|CitizenStatements.DocumentHistory",
            Localize: true
        }
        ],
        Text: "Печать",
        ToolTip: "Подменю_печати",
        Type: null,
        Localize: true
    }
];
const archiveResolutionToolbar = [
    {
        Action: "PrintFishka",
        Icon: "print",
        Items: null,
        Text: "Печать_фишки",
        ToolTip: "Печать_фишки_поручения",
        Type: "Documents|Orders|CitizenStatements.Fishka",
        Localize: true
    }
];
const archiveEuolStatementToolbar = [
    {
        Action: "PrintCard",
        Icon: "print",
        Items: null,
        Text: "Печать_карточки",
        ToolTip: "Печать_карточки_документа",
        Type: "Chancellery|Documents|CitizenStatements.DocumentCard",
        Localize: true
    }
];
const icons = {
    document_add: "far fa-file",
    print: "far fa-print",
    edit: "far fa-edit",
    attach_add: "far fa-paperclip",
    doc_begin_adjustment: "far fa-share-square",
    sign_send: "far fa-file-signature",
    doc_register_send: "far fa-external-link-alt",
    doc_send_link: "far fa-external-link-alt",
    copy: "far fa-copy",
    document_link: "far fa-external-link-square-alt",
    doc_delete: "far fa-trash",
    exit_editing: "far fa-arrow-left",
    save: "far fa-save",
    save_and_close: "far fa-times-circle",
    doc_set_adjustment: "far fa-handshake",
    doc_send: "far fa-paper-plane",
    sign: "far fa-signature",
    sign_add: "far fa-file-signature",
    sign_verify: "far fa-file-contract",
    process_start: "far fa-project-diagram",
    process_base_start: "far fa-play",
    send_to_view: "far fa-eye",
    resolution_add: "far fa-marker",
    doc_register: "far fa-list-ol",
    doc_reject: "far fa-undo",
    remove_answer: "far fa-reply",
    execute_statement: "far fa-edit",
    doc_register_nonum: "far fa-file-prescription",
    doc_attach: "far fa-file-alt",
    doc_take_on_control: "far fa-stopwatch",
    resolution_prolongate: "far fa-calendar-alt",
    change_executer: "far fa-exchange-alt",
    doc_take_off_control: "far fa-flag-checkered",
    act_item_add: "far fa-plus-square",
    refresh: "far fa-sync-alt",
    make_report: "far fa-search",
    doc_reject_cancel: "far fa-trash-restore",
    document: "far fa-file",
    execution_resend: "far fa-share-square",
    execution_send: "far fa-check-circle",
    reserve: "far fa-tasks",
    doc_register_cancel: "far fa-undo",
    change_control: "far fa-pen-square",
    prolongate_control: "far fa-calendar-day",
    add: "far fa-plus",
    group_add: "far fa-plus",
    person_add: "far fa-plus",
    contact_add: "far fa-plus",
    enterprise: "far fa-landmark",
    person: "far fa-user",
    move_to_euol: "far fa-external-link-alt",
    change_number: "far fa-exchange-alt",
    change_nomenclature: "far fa-exchange-alt",
    withdraw_adjustment: "far fa-comment-slash",
    doc_return: "far fa-reply-all",
    set_inspected: "far fa-check",
    accept_invoice: "far fa-file-invoice-dollar",
    add_invoice: "far fa-file-invoice",
    execution_closed: "far fa-user-check",
    del: "far fa-undo",
    add_comment: "far fa-comment",
    make_contract: "far fa-file-contract",
    contract_send_to_sign: "far fa-file-signature",
    lockuser: "far fa-lock",
    unlockuser: "far fa-lock-open",
    send_eecb: "far fa-paper-plane",
    disconnect: "far fa-user-slash",
    delemployee: "far fa-user-slash",
    reset_pas: "far fa-cogs",
    move_to_archive: 'far fa-box',
    move_from_archive: 'far fa-box-open',
    add_section_answer: 'far fa-external-link-square-alt',
    CancelExecution: 'far fa-undo',
    send_exec: 'far fa-vote-yea',
    edit_recip_list: 'far fa-unlock-alt',
    reportform_send: 'far fa-file-export',
    ex_groups: 'mdi-account-group',
    send_prolongattion_request: 'far fa-flip-horizontal fa-clock-rotate-left',
    accept_prolongattion_request: 'far fa-check',
    column: 'far fa-window-maximize',
    two_column: 'fas fa-columns'
}

const toolbar = {
    namespaced: true,
    state: {
        menu: [],
        isLock: false,
        lockedActions: []
    },
    mutations: {
        SET_MENU(state, payload) {           
            state.menu = payload.menu;
        },
        SET_ISLOCK(state, payload) {     
            state.isLock = payload.isLock;
        },
        SET_BTNLOCK(state, payload){
            state.lockedActions.push(payload.lockedAction);
        },
        SET_BTNUNLOCK(state, payload){
            let idx = state.lockedActions.indexOf(payload.lockedAction);
            if (idx > -1) {
                state.lockedActions.splice(idx,1);
            }
        }
    },
    actions: {
        setMenu({ commit }, { menu }) {
            commit({ type: 'SET_MENU', menu });
        },
        setToolbarIsLock({ commit }, isLock) {
            commit({ type: 'SET_ISLOCK', isLock });
        },
        setButtonLock({ commit }, lockedAction) {
            commit({ type: 'SET_BTNLOCK', lockedAction });
        },
        setButtonUnLock({ commit }, lockedAction) {
            commit({ type: 'SET_BTNUNLOCK', lockedAction });
        },
    },
    getters: {
        isToolbarLock: (s) => s.isLock,
        lockedActions: (s) => s.lockedActions,  
        getIcons: () => icons,
        getMenu(s, g, rs, rg) {
            let module = rg['getCurrentModule'];
            let result = Array.from(s.menu.filter(a => !a.Portable));

            if (module === "archive") {
                let currentRouteName = router?.currentRoute?.name;
                let cardType = archiveCardsTypes[currentRouteName];

                switch (cardType)
                {
                    case "Document":
                        result = archiveDocumentToolbar;
                        break;

                    case "Resolution":
                        result = archiveResolutionToolbar;
                        break;

                    case "Euol":
                        result = archiveEuolStatementToolbar;
                        break;

                    default: break;
                }
            }

            return result;
        },
        getActionButtons: (s) => s.menu.filter(a => a.Portable)
    },
};

export default toolbar;